import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class RoleApi {
  public roles(): Observable<StaticDataDAO[]> {
    return of([
      { id: 'Admin', name: 'Admin' },
      { id: 'Editor', name: 'Editor' }
    ]);
  }
}
